import { useTranslation } from "react-i18next";
import { TextInput } from "@/shared/ui";

type Props = {
  price: string;
  setPrice: (value: string) => void;
};

export default function VehicleOfferPriceOffer({ price, setPrice }: Props) {
  const { t } = useTranslation("vehicle");
  return (
    <div className="mb-5">
      <p className="mb-2 text-16 font-medium">{t("sell.suggestion")}:</p>
      <TextInput
        value={price}
        onChange={setPrice}
        placeholder={t("sell.suggestionCost")}
        icon="₽"
        isIconRight
        maxLength={11}
      />
    </div>
  );
}
